import { useMutation, useQuery, useQueryClient } from 'react-query'
import { getItemCategories, saveItemCategories } from './itemCategoriesApi'
import { ItemCategoriesState } from './itemCategoriesModel'
import { notification } from 'antd'

export const useItemCategories = () => {
  return useQuery(['itemCategories'], getItemCategories)
}

type SaveItemCategoriesRequest = {
  changeSet: ItemCategoriesState
}

export const useSaveItemCategoriesMutation = (onSuccess: () => void) => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ changeSet }: SaveItemCategoriesRequest) => saveItemCategories(changeSet),
    onSuccess: () => {
      queryClient.invalidateQueries(['itemCategories'])
      onSuccess()
    },
    onError: () => {
      notification.error({ message: 'There was an error saving item categories. Please try again later.' })
    }
  })
}
